import { Col, Row } from "antd";
import { useQueries } from "react-query";
import {
  getOMCustomerInfo,
  getOMProductInfo,
  getOMReservationInfo,
} from "../../../../../apis/OrderManagement/order";
import { getOrderMemoByOrderNo } from "../../../../../apis/orderMemo";
import { ListResponse } from "../../../../../model/common/ListResponse";
import { BoldDivider } from "../../../Divider/bold";
import { Section } from "../index.styled";
import { RepairCsMemoInfoForm } from "./CsMemo";
import { RepairCustomerInfoForm } from "./Customer";
import { RepairOrderInfoForm } from "./Order";
import { RepairVehicleInfoForm } from "./Vehicle";

interface RepairReservationInfoFormProps {
  repairNo?: string;
}

/**
 * 매장현황 - 예약정보
 * @returns
 */
export const RepairReservationInfoForm: React.FC<
  RepairReservationInfoFormProps
> = ({ repairNo }) => {
  const [
    { data: reservationData },
    { data: customerData },
    { data: productData },
    { data: inquriyData },
  ] = useQueries([
    {
      queryKey: ["OM", repairNo, "OrderReservationInfo"],
      queryFn: () => getOMReservationInfo(repairNo as string),
      enabled: !!repairNo,
      refetchOnMount: "always",
    },
    {
      queryKey: ["OM", repairNo, "OrderCustomerInfo"],
      queryFn: () => getOMCustomerInfo(repairNo as string),
      enabled: !!repairNo,
      refetchOnMount: "always",
    },
    {
      queryKey: ["OM", repairNo, "OrderProductInfo"],
      queryFn: () => getOMProductInfo(repairNo as string),
      enabled: !!repairNo,
      refetchOnMount: "always",
    },
    {
      queryKey: ["OM", repairNo, "CsMemo"],
      queryFn: () => getOrderMemoByOrderNo(repairNo as string),
      enabled: !!repairNo,
      refetchOnMount: "always",
      refetchInterval: 1000 * 60 * 5,
      select: (data: ListResponse<any>) =>
        data?.rows?.filter((item) => item.repairShopViewable),
    },
  ]);

  return (
    <Section style={{ padding: 0, height: "100%", position: "relative" }}>
      <Row gutter={[0, 0]}>
        {!!inquriyData?.length && (
          <>
            <Col span={24}>
              <RepairCsMemoInfoForm repairNo={repairNo} />
            </Col>
            <BoldDivider />
          </>
        )}
        <Col span={24}>
          <RepairVehicleInfoForm dataSource={customerData?.vehicle} />
        </Col>
        <BoldDivider />
        <Col span={24}>
          <RepairCustomerInfoForm dataSource={customerData?.customer} />
        </Col>
        <BoldDivider />
        <Col span={24}>
          <RepairOrderInfoForm
            repairNo={repairNo}
            reservationInfo={reservationData?.rows}
            productInfo={productData?.rows}
            isDomestic={customerData?.vehicle?.isDomestic}
          />
        </Col>
      </Row>
    </Section>
  );
};
